import firebase from 'firebase/app' //подключение файрбайза к данному файлу
export default {
	state:{		//возвр объект у которого поле сейит и поле инфо
		info:{}		    //по умолч поле инфо  равняющ пустому объекту
		//если в стейте ничего нет то никаких данных о пользов нет
	},
	mutations:{
		setInfo(state, info){//принимает стейт и инфо и зменяем стейт напрямую
		state.info = info
	},
	clearInfo(state)   //метод принимает в себя стейт и определяет стейт инфо равное пустому объекту
	{
		state.info = {}   //чтобы форнтенд не кешировал в стейте когда будем делать логаут
	}
	},
	actions:{
		async updateInfo({dispatch, commit, getters}, toUpdate) {
      try {
        const uid = await dispatch('getUid')
        const updateData = {...getters.info, ...toUpdate}
        await firebase.database().ref(`/users/${uid}/info`).update(updateData)
        commit('setInfo', updateData)
      } catch (e) {
        commit('setError', e)
        throw e
      }
    },


				//акшены фечт инфо
		async fetchInfo({dispatch, commit}){//обратиться к бд и получить поле инфо у конкр пользователя для этого нужно знать его uid - в контексте получим поле диспатч
			  
			try{    // блок трай кетч для того чтобы обработать потенциальные ошибки
				const uid = await dispatch('getUid')
				 									 //принимаем оператор ивейт чтобы получить uid пользователя
				const info = (await firebase.database().ref(`/users/${uid}/info`).once('value')).val() //подкл к бд указыаем путь до поля бд которое необх получить
				 //кавычки были не те!!!!!!!!!!!!!!!!! получение из бд поэтому не работало!!!!!!!!!!!! 
				// console.log('info', info) //не выводит
				commit('setInfo', info) //где вызвать метод setinfo куда передадим инфо для того чтобы изменить стейт
		
			}catch(e){
					commit('seError', e)
				throw e
			}
			 
		}	 
	},
	getters:{ //для того чтобы получить стейт надо реализовать геттеры
		info: s=>s.info //это функция принимает в себя стейт и возвр поле из стейта инфо
	}
}

//далее этот модуль подключается в индекс жс